import { type DefinitionNode } from 'graphql';
import { type GraphQLTaggedNode } from 'react-relay';
import { type ConcreteRequest } from 'relay-runtime';

export type RelayOperationVariables = Record<string, any> | undefined;

function sanitizeOperationKey(operationName: string): string {
	return operationName.replace(/[^\-.\w]/g, '_');
}

export function getRelayOperationName(query: GraphQLTaggedNode): string | null {
	if ('params' in query) {
		return (query as ConcreteRequest).params?.name ?? null;
	}

	if ('definitions' in query) {
		const definition = (query as { definitions: readonly DefinitionNode[] }).definitions?.find(
			(d): d is DefinitionNode & { name?: { value: string } } =>
				d.kind === 'OperationDefinition' && 'name' in d,
		);
		return definition?.name?.value ?? null;
	}

	return null;
}

export function getRelayOperationKey(
	operationName: string | null | undefined,
	_variables?: RelayOperationVariables,
): string | null {
	if (!operationName) {
		return null;
	}

	return sanitizeOperationKey(operationName);
}
